<script>
import CommonConstants from '../../common/Constants.js';
import config from '../../common/genericPanelConf';
import Service from '../../services/planning';
import Dialog from 'primevue/dialog';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import Utils from '../../common/Utils';

export default {
    props: ['visible'],
    emits: ["close-import-dialog"],
    components: {
        Dialog
    },
    created(){
        this.config = config.getConfiguration('biodieselMixingReport');
    },
    mounted(){

    },
    data(){
        return{
            showImportPreview: false,
            importFromFileData: {
                monthDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
                initialInventoryDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
                endInventoryDate: Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 0)),
                fileBase64: null
            },
            getWeeklyDataFromExcel: [],
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
    },
    watch: {       
    },
    methods: {
        closeDialog(value) {
            this.$emit("close-import-dialog", value);
        },
        async uploaderResponseMethod(file){
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
            });
            const base64 = await toBase64(file.files[0]);
            const fileName = file.files[0].name;
            let body = {
                monthDate: Utils.formatDateForAPI(this.importFromFileData.monthDate),
                initialInventoryDate: this.importFromFileData.initialInventoryDate,
                endInventoryDate: this.importFromFileData.endInventoryDate,
                fileBase64: base64,
                fileNameWithExtension: fileName
            }
        
            this.$store.dispatch("generic/setLoading", true);
            Service.getWeeklyDataFromExcel(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success && response.data){
                    this.closeDialog(true);
                    this.showImportPreview = true;
                    this.getWeeklyDataFromExcel = response.data;

                    for(let i = 0; i < this.getWeeklyDataFromExcel.length; i++){
                        let item = this.getWeeklyDataFromExcel[i];
                        item.initialInventoryDate = item.initialInventoryDate ? Utils.dateToCurrentTimeZone(item.initialInventoryDate) : null;
                        item.endingInventoryDate = item.endingInventoryDate ? Utils.dateToCurrentTimeZone(item.endingInventoryDate) : null;
                        item.settlementDate = item.settlementDate ? Utils.dateToCurrentTimeZone(item.settlementDate) : null;
                    }
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onCellEditComplete(data){
            data.data[data.field] = data.newData[data.field];
        },
        saveData(){
        this.$confirm.require({
            message: this.$t('messages.confirm_import'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {                  
                let body = {
                    provisionalInvoices: this.getWeeklyDataFromExcel
                }

                this.$store.dispatch("generic/setLoading", true);
                Service.importProvisionalInvoiceFromExcel(body, 
                    response => {   
                    this.$store.dispatch("generic/setLoading", false);      
                    if(response.success){
                        this.showImportPreview = false;
                        this.getWeeklyDataFromExcel = [];
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        }
    }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="showImportPreview" modal>            
            <DataTable :value="getWeeklyDataFromExcel" dataKey="id" tableStyle="min-width: 50rem" editMode="cell" 
            @cell-edit-complete="onCellEditComplete" showGridlines stripedRows >

                <Column field="initialInventoryDate" :header="$t('provisionalInvoice.initialInventoryDate')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                  </template>
                </Column>

                <Column field="endingInventoryDate" :header="$t('provisionalInvoice.endingInventoryDate')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                  </template>
                </Column>

                <Column field="weeklyDescription" :header="$t('provisionalInvoice.weeklyDescription')"></Column>

                <Column field="familyGroup" :header="$t('provisionalInvoice.familyGroup')"></Column>

                <Column field="familyPool" :header="$t('provisionalInvoice.familyPool')"></Column>

                <Column field="cubicMeters" :header="$t('provisionalInvoice.cubicMeters')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3"/>
                  </template>
                </Column>

                <Column field="density" :header="$t('provisionalInvoice.density')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 4) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="4"/>
                  </template>
                </Column>

                <Column field="conversionFactor" :header="$t('provisionalInvoice.conversionFactor')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3"/>
                  </template>
                </Column>

                <Column field="barrels" :header="$t('provisionalInvoice.barrels')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3"/>
                  </template>
                </Column>

                <Column field="metricTonnes" :header="$t('provisionalInvoice.metricTonnes')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3"/>
                  </template>
                </Column>

                <Column field="settlementBase" :header="$t('provisionalInvoice.settlementBase')">
                  <template #body="{ data, field }">
                    <span>{{data[field]}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputText v-model="data[field]" type="text"/>
                  </template>
                </Column>

                <Column field="settlementDate" :header="$t('provisionalInvoice.settlementDate')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                  </template>
                </Column>

                <Column field="settle" :header="$t('provisionalInvoice.settle')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3"/>
                  </template>
                </Column>

                <Column field="premiumOrDiscount" :header="$t('provisionalInvoice.premiumOrDiscount')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3"/>
                  </template>
                </Column>

                <Column field="escalatedPrice" :header="$t('provisionalInvoice.escalatedPrice')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3"/>
                  </template>
                </Column>

                <Column field="invoiceAmount" :header="$t('provisionalInvoice.invoiceAmount')">
                  <template #body="{ data, field }">
                    <span>{{data[field] != null ? utils.formatDecimal(data[field], 2) : null}}</span>
                  </template>
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="2"/>
                  </template>
                </Column>
            </DataTable>

            <template #footer>
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="m-2 p-button-sm" @click="saveData" />
              </template>
          </Dialog>

          <Dialog :visible="visible" modal :style="{ width: '25vw'}">
            <div class="grid">
                <Button icon="pi pi-times" class="p-button-sm close-button" @click="closeDialog(true)" />
            </div>
            <div class="field">
              <label for="MonthDate">{{ $t('tollingPrice.monthDate') }}</label>
              <Calendar
                  :class="{'p-inputtext-sm w-full': true}"
                  :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                  view="month" dateFormat="mm/yy"
                  :showTime="false"
                  v-model="importFromFileData.monthDate"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>

            <div class="field">
              <label for="InitialInventoryDate">{{ $t('provisionalInvoice.initialInventoryDate') }}</label>
              <Calendar 
                  class="w-full" 
                  v-model="importFromFileData.initialInventoryDate" 
                  dateFormat="dd/mm/yy" 
                  placeholder="dd/mm/yyyy"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" /> 
            </div>

            <div class="field">
              <label for="EndInventoryDate">{{ $t('provisionalInvoice.endingInventoryDate') }}</label>
              <Calendar 
                  class="w-full" 
                  v-model="importFromFileData.endInventoryDate" 
                  dateFormat="dd/mm/yy" 
                  placeholder="dd/mm/yyyy"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                  /> 
            </div>

            <div class="field">
              <FileUpload name="uploaded[]" :customUpload="true" @uploader="uploaderResponseMethod" :previewWidth="0" :fileLimit="1" :multiple="false" />      
            </div>
          </Dialog>
    </main>
</template>

<style>
    .close-button{
        position: absolute;
        top: 20px;
        left: 10px;
    }
</style>